export function activityPlanDefaultNotificationDataInjector(activityPlanNotification) {
  const sourceId = activityPlanNotification.sourceId
  const variablesForUse = activityPlanNotification.variablesForUse

  activityPlanNotification.setOnClick((notificationDataFromComponent) => {
    variablesForUse.navigate(`/plan/${sourceId}`)
  })
}
